import React from "react";
import Spinner from "../presentationals/Spinner";
import { roundToTwo, timeStampFormat } from "../../utils/common/index";

export default function CustomCardEd1(props) {
  function csvHandler(e) {
    e.preventDefault();
    props.csvDownload();
  }
  return (
    <>
      <div className="col-md-4">
        <div
          className={`grad${props.gradient} whiteoverlaycir `}
          data-cy="custom-card"
        >
          <div
            className={`leftdiv ${
              props.percentage ? "col-7" : "col-10"
            } m-0 p-0`}
          >
            {props.cardTitle ? (
              <div className="subtitlebox">
                <p>{props.cardTitle}</p>
              </div>
            ) : (
              <div className="icon">
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/images/icons/paper.svg"
                  }
                  alt="billed"
                />
              </div>
            )}
            <div className="row">
              <div className="titletxt col-6">
                {props.tileName1}
                <span>
                  {props.value1 !== "null" ? roundToTwo(props.value1) : 0}
                </span>
              </div>
              <div className="titletxt col-6">
                {props.tileName2}
                <span>
                  {props.value2 !== "null" ? roundToTwo(props.value2) : 0}
                </span>
              </div>
            </div>
          </div>
          <div className={`rightdiv ${props.percentage ? "col-5" : "col-2"}`}>
            {props.csvDownload && (
              <div className="dowloaddiv float-right mr-3 mr-sm-0">
                {props.loading ? (
                  <Spinner showAlert={false} />
                ) : (
                  <span className="downloadarrow">
                    <button
                      type="button"
                      data-cy={props?.tileName?.replace(/ /g, "-")}
                      className="btn btn-link btn-sm m-0 p-0"
                      onClick={csvHandler}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icons/download-arrow-w.svg"
                        }
                        alt="download"
                      />
                    </button>
                  </span>
                )}
              </div>
            )}
            <div className="dowloaddiv"></div>
          </div>
        </div>
        {props.timestamp ? (
          <div
            className="card-timestamp border-top mt-2"
            data-cy="card-timestamp"
          >
            <i className="fa fa-history mr-2 mt-2 mb-0"></i>Updated on{" "}
            {timeStampFormat(props.timestamp.tileTimestamp)}
          </div>
        ) : null}
      </div>
    </>
  );
}
